import FAQ from "images/homepage/FAQ";
import React from "react";
import styled from "styled-components";
import FAQCard from "./FAQCard";
import { Link } from "gatsby";
import SeeAllButton from "components/buttons/SeeAllButton";
import { useTranslation } from "react-i18next";

const Container = styled.section.attrs({ className: "container" })`
    margin-top: 0px;
    @media (min-width: 992px) {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin-top: 150px;
    }
`;

const Heading = styled.h1`
    font-style: normal;
    font-weight: 800;
    line-height: 100%;
    text-align: left;
    margin-top: -80px;
    margin-left: 130px;
    font-size: 72px;
    margin-bottom: 65px;

    @media (max-width: 576px) {
        margin-left: 0;
        text-align: center;
        margin-top: -160px;
        font-size: 54px;
    }
`;

const FAQIcon = styled(FAQ)`
    @media (max-width: 576px) {
        width: 120px;
    }
`;

interface FAQItem {
    question: React.ReactNode;
    answer: React.ReactNode;
}

interface FAQsProps {
    faqItems: FAQItem[];
}

export default function FAQs({ faqItems }: FAQsProps) {
    const [active, setActive] = React.useState(-1);
    const { t } = useTranslation();

    return (
        <Container>
            <FAQIcon />
            <Heading>{t("EP_INDEX_FAQ_TITLE")}</Heading>
            {faqItems.map((faq, index) => (
                <FAQCard
                    key={index}
                    question={faq.question}
                    answer={faq.answer}
                    onClick={() => setActive(active === index ? -1 : index)}
                    expanded={active === index}
                />
            ))}
            <div className="d-flex justify-content-center">
                <Link
                    to="https://help.ente.io/photos/faq/general"
                    tabIndex={-1}
                >
                    <SeeAllButton>
                        {t("EP_INDEX_FAQ_SEE_ALL_BUTTON")}
                    </SeeAllButton>
                </Link>
            </div>
        </Container>
    );
}
